import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=1818dfd0&scoped=true&lang=pug&"
import script from "./Purchases.vue?vue&type=script&lang=js&"
export * from "./Purchases.vue?vue&type=script&lang=js&"
import style0 from "./Purchases.vue?vue&type=style&index=0&id=1818dfd0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818dfd0",
  null
  
)

export default component.exports